import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useDispatch, useSelector } from 'react-redux';
import BlogPosts from '../../components/BlogPosts';
import AssetClassHeader from '../../components/AssetClassHeader';
import { setSelectedFilters, setFilteredPosts } from '../../redux/slices';

const TTCContainer = (props) => {
  const dispatch = useDispatch();
  const { stories = [] } = props;
  const postsToPublish = stories;
  const filteredPosts = postsToPublish.filter(post => post.postTitle !== '');

  const assetClasses = useSelector(state => state.app);
  const groupWrapper = useRef(null);
  const { filters } = assetClasses;

  const onChange = async (updatedFilters) => {
    await dispatch(setSelectedFilters(updatedFilters));
    await dispatch(setFilteredPosts(filteredPosts));
  };

  useEffect(() => {
    dispatch(setFilteredPosts(filteredPosts));
  }, [stories, filters]);

  return (
    <>
      <header>
        <Row className="mb-4 justify-content-end px-3 content">
          <Col xs={6} className="col-md-auto  p-3">
            <AssetClassHeader
              options={filters}
              onChange={onChange}
            />
          </Col>
        </Row>
      </header>
      <main ref={groupWrapper} className="content">
        <section className="">
          <BlogPosts postsToPublish={filteredPosts} filters={filters} />
        </section>
      </main>
    </>
  );
};

TTCContainer.propTypes = {
  stories: PropTypes.shape([]).isRequired,
};

export default TTCContainer;
